// extracted by mini-css-extract-plugin
module.exports = {"image":"GW-z","loaded":"HW-z","placeholder":"IW-z"};